import Web3Utils from "web3-utils";

export function formatWei(input, unit = "ether") {
  return parseFloat(
    Web3Utils.fromWei(input.toString(), unit)
  );
}
